<template>
  <div>
    <br />
    <div class="row">
      <div class="row" style="padding-bottom: 10px">
        <div class="col-md-2">
          <label for="starDate">{{$t('Tarixdən')}}</label>
          <el-date-picker size="small" id="starDate" format="dd.MM.yyyy" type="date" :clearable="false"
            v-model="item.startDate">
          </el-date-picker>
        </div>
        <div class="col-md-2">
          <label for="endDate">{{$t('Tarixədək')}}</label>
          <el-date-picker size="small" id="endDate" format="dd.MM.yyyy" type="date" :clearable="false"
            v-model="item.endDate">
          </el-date-picker>
        </div>
        <div class="col-md-8" style="padding-bottom: 10px">
         <label>{{$t('Axtarış_növü')}}</label>
          <div class="d-flex justify-content-start">
            <div class="d-flex flex-row">
              <el-select style="width: 90%" size="small" v-model="item.searchType">
                <el-option :label="$t('--_Bütün_--')" :value="0"></el-option>
                <el-option :label="$t('İş_nömrəsi')" :value="1"></el-option>
                <el-option label="Müştəriyə görə" :value="2"></el-option>
              </el-select>
              &nbsp;
              <el-input size="small" :placeholder="$t('Axtar')" :disabled="item.searchType == 0" v-model="item.searchText">
                <template slot="prepend"> </template>
              </el-input>
              &nbsp;
              <el-button size="small" :title="$t('Axtarış')" type="primary" icon="el-icon-search" @click="getData"></el-button>
            </div>
          </div>
        </div>
        <div class="col-md-8 col-12">
          <!-- <el-checkbox @change="getData" v-model="item.newClaim">{{$t('İş_açılıb')}}</el-checkbox>
        <el-checkbox @change="getData" v-model="item.noResponsible">{{$t('Məsul_şəxs_təyin_olunmayıb')}} </el-checkbox> -->
        </div>
      </div>
      <div class="col-12">
        <el-table v-loading="loading" :data="data.filter(
          (data) =>
            !search ||
            data.regNumber.toLowerCase().includes(search.toLowerCase()) ||
            data.dispClaimNumber.toLowerCase().includes(search.toLowerCase())
        )
          " style="width: 100%">
          <el-table-column :label="$t('Göndəriş_№')" sortable prop="policyNumber" width="180">
          </el-table-column>
          <el-table-column :label="$t('Göndəriş_tarixi')" prop="referralDateStr" width="200">
          </el-table-column>
          <el-table-column :label="$t('Təmir_mərkəzinin_adı')" prop="serviceCenterName" width="250">
          </el-table-column>
          <el-table-column :label="$t('DQN')" prop="regNumber" width="150">
          </el-table-column>
          <el-table-column :label="$t('Müştərinin_adı')" prop="clientName" width="250">
          </el-table-column>
          <el-table-column :label="$t('Müştərinin_nömrəsi')" prop="clientPhone" width="150">
          </el-table-column>
          <el-table-column :label="$t('Marka')" prop="customBrand" width="150">
          </el-table-column>
          <el-table-column :label="$t('Model')" prop="customModel" width="150">
          </el-table-column>

          <!-- <el-table-column :label="$t('Sığortalı')" prop="insuredName" width="300">
          </el-table-column>
          <el-table-column :label="$t('Sığortalı_№')" prop="phone" width="150">
          </el-table-column>
          <el-table-column :label="$t('Sığorta_predmeti')" prop="brandModel" width="250">
          </el-table-column>

          <el-table-column :label="$t('Hadisə_məlumatları')" prop="place">
          </el-table-column> -->
          <!-- <el-table-column fixed="right" width="88">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-button @click="handleEdit(scope.row.id)" type="text"
                style="padding: 0 0 0 0 !important;color: #808080;">
                <div class="square-icon">
                  <i class="fa-solid fa-pen-to-square" title="Düzəliş"></i>
                </div>
              </el-button>
            </template>
          </el-table-column> -->

          <el-table-column fixed="right" width="50">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-button @click="handleEdit(scope.row.referralId)" type="text"
                style="padding: 0 0 0 10px !important;color: #808080;">
                <div class="square-icon">
                  <i class="fa-solid fa-up-right-from-square" title="Hadisəyə keçid"></i>
                </div>
              </el-button>
            </template>
          </el-table-column>
          <el-table-column align="right" fixed="right" width="45">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-dropdown trigger="click" @command="handleCommand">
                <el-button type="text" class="custom-button" style="padding: 0 10px 0 0 !important;">
                  <div class="square-icon">
                    <i class="fas fa-ellipsis-h" :title="$t('Ləğv_et')" style="color: #808080;"></i>
                  </div>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <!-- <el-dropdown-item :command="{ action: 'edit', row: scope.row }"><i
                      class="fa-solid fa-pen-to-square"></i>{{$t('Düzəliş')}}</el-dropdown-item>
                  <el-dropdown-item divided></el-dropdown-item> -->
                  <el-dropdown-item :command="{ action: 'delete', row: scope.row }"><i
                      class="fa-solid fa-trash-can"></i>{{$t('Ləğv_et')}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GetClaimReferrals,
} from "src/services/carep";
import { DateToString, AddMonths, AddDays } from "../../services/helper";
export default {

  data() {
    return {
      mydata: false,
      loading: false,
      data: [],
      search: "",
      accident: {},
      uid: this.$store.state.user.id,
      commNotification: [],
      item: {
        startDate: null,
        endDate: null,
        searchType: 0,
        searchText: null,
        uid: null
      },
      cells: {
        'Zəng tarixi': 'callDateStr',
        'Hadisə tarixi': 'accidentDateStr',
        'Sığortalı': 'insuredName',
        'SŞ nömrəsi': 'policyNumber',
        'DQN': 'regNumber',
        'Marka model': 'brandModel',
        'Sürücü"': 'driver',
        'Sürücü nömrəsi"': 'driverPhone',
        'Hadisə yeri': 'place',
        'Təfərrüat': 'descr',
        'Sürücünün qeydləri': 'callNotes',
      },
    };
  },
  methods: {

    newMotorAccident() {
      this.$refs["accident"].new();
    },
    newOtherAccident() {
      this.$refs["otherAccident"].new();
    },


    saved(value) {
      this.handleComm(value.id);
      this.getData();
    },
    handleCommand(command) {
      let id = command.row.id;
      // if (command.action === "edit") this.handleEdit(id);
      // else
      if (command.action === "comm") this.handleComm(id);
      else if (command.action === "delete") this.handleDelete(id);
    },
    handleEdit(id) {
      let routeData = this.$router.resolve({ path: "../carep/" + id });
      window.open(routeData.href, "_blank");
    },


    getData() {
      this.loading = true;
      GetClaimReferrals().then((response) => {
        this.loading = false;
        if (response.data) {
          this.data = response.data;
          this.item.startDate = DateToString(this.item.startDate);
          this.item.endDate = DateToString(this.item.endDate);
        }
      });
    },
    loadTime() {
      this.item.startDate = AddMonths(new Date(), -6);
      this.item.endDate = AddDays(new Date(), +1);
    },

  },
  mounted() {
    this.getData();
    this.loadTime();
  },
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
